import type { Pinia } from 'pinia';
import { useMainStore } from '~/store';
import { useFacilityStore } from '~/store/facility';
import { useNotificationStore } from '~/store/notification';
import { usePlanningGroupStore } from '~/store/planningGroupStore';
import { useSidebarStore } from '~/store/sidebar';

export default defineNuxtPlugin(({ $pinia }) => {
  const pinia = $pinia as Pinia;
  return {
    provide: {
      // ToDo: Properly define type of `store` once we've moved to TypeScript
      store: useMainStore(pinia),
      facilityStore: useFacilityStore(pinia),
      planningGroupStore: usePlanningGroupStore(pinia),
      notificationStore: useNotificationStore(pinia),
      sidebarStore: useSidebarStore(pinia),
    },
  };
});
